import React from 'react'
import { Box } from '@mui/material'
import { useLocation } from 'react-router-dom'
import Login from '../../Pages/Login'
import Layout from '.'

const MainLayout = ({ children }) => {
    const location = useLocation()
    return (
        <Box>
            {location?.pathname === "/login" ? <Login /> : <Layout children={children} />}
        </Box>
    )
}

export default MainLayout
